<template>
  <div class="TestPaperReport">
    <AppHeader content="测验报告"></AppHeader>
    <AppBox class="appBox" id="appBox">
      <date-select ref="dateSelector" @pick="dataPick"></date-select>
      <el-row class="el-row-1">
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>参与总人数</span>
            </div>
            <div class="block-value">{{ this.data.totalUser }}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>完成人数</span>
            </div>
            <div class="block-value">{{ this.data.finishUser }}</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>答题准确率</span>
            </div>
            <div class="block-value">{{ ((this.data.correctRate ? this.data.correctRate : 0) * 100).toFixed(1) }}%</div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>平均答题耗时</span>
            </div>
            <div class="block-value">{{ ((this.data.avgTime ? this.data.avgTime : 0) / 1000).toFixed(1) }}秒
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="el-row-2">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>错题</span>
            </div>
            <el-table class="report-table"
                      :data="data.questionErrors"
                      style="width: 100%">
              <el-table-column
                  prop="title"
                  label="题目">
              </el-table-column>
              <el-table-column
                  prop="errorCount"
                  label="错误人数">
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>测试详情</span>
            </div>
            <el-table class="report-table"
                      :data="data.userTestReports"
                      style="width: 100%">
              <el-table-column
                  prop="phone"
                  label="手机号">
              </el-table-column>
              <el-table-column
                  sortable
                  prop="answerCount"
                  label="回答题数">
              </el-table-column>
              <el-table-column
                  sortable
                  prop="correctRate"
                  label="正确率">
                <template slot-scope="scope">
                  <div>{{ ((scope.row.correctRate ? scope.row.correctRate : 0) * 100).toFixed(1) }}%</div>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {mapActions} from "vuex";
import Base64 from "@/utils/base64";
import DateSelect from "@/components/dateSelect/index.vue";
import extend from "@/components/ui/AppTable/extend";

export default {
  name: "TestPaperReport",
  components: {extend, DateSelect, AppHeader, AppBox},
  data() {
    return {
      data: {
        totalUser: 0,
        finishUser: 0,
        correctRate: 0,
        avgTime: 0,
        questionErrors: [],
        userTestReports: [],
      },
      testPaperId: 0,
      dateRange: [new Date().getTime() - 1000 * 3600 * 24, new Date().getTime()],
    };
  },
  async mounted() {
    this.testPaperId = Base64.decode(this.$route.params.testPaperId);
    this.$refs.dateSelector.dateRange = this.dateRange;
    await this.loadData();
  },
  methods: {
    ...mapActions("pluginCenter", ["getTestPaperTestReport"]),
    async loadData() {
      let testPaperTestReport = await this.getTestPaperTestReport({
        id: this.testPaperId,
        startTime: this.dateRange[0],
        endTime: this.dateRange[1]
      });
      this.data = testPaperTestReport.data;
    },
    dataPick(dateRange) {
      this.dateRange = dateRange;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.TestPaperReport {
  .appBox {
    height: calc(100vh - 155px);
    min-height: 330px;
    overflow-y: auto;

    .el-row-1 {
      padding: 1rem 0;
      height: 12rem;
    }

    .el-row-2 {
      padding: 1rem 0;
      height: 24rem;
    }

    .box-card {
      border-radius: 1rem;
      margin: 0 2rem;
    }

    .block-value {
      height: 4rem;
      color: lawngreen;
      font-size: 2rem;
      text-align: center;
      justify-content: center;
      display: flex;
      align-items: center;
    }

    .report-table {
      overflow-y: auto;
      height: 24rem;
    }
  }
}
</style>
